import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = 'https://aaktradex.in';

const C = {
  green: '#3B6D11', lgreen: '#EAF3DE', bgreen: '#C0DD97',
  amber: '#854F0B', lamber: '#FAEEDA', bamber: '#FAC775',
  red:   '#A32D2D', lred:   '#FCEBEB', bred:   '#F7C1C1',
  blue:  '#185FA5', lblue:  '#E6F1FB', bblue:  '#B5D4F4',
  purple:'#6B21A8', lpurple:'#F3E8FF', bpurple:'#C4B5FD',
  gray:  '#6B7280', lgray:  '#F3F4F6', bgray:  '#D1D5DB',
};

function todayISO() {
  const d = new Date();
  return d.toISOString().split('T')[0];
}

function plusDaysISO(n) {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().split('T')[0];
}

export default function RecosPanel() {
  const [recos, setRecos] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    ticker: '', source: '', reason: '',
    applies_from_date: todayISO(), applies_to_date: plusDaysISO(7),
    target_strategy: 'sectortrade', notes: '',
    reco_price: '', target_1: '', target_2: '', sl_price: '',
  });

  const fetchRecos = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/recos/active`);
      setRecos(r.data.recos || []);
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => {
    fetchRecos();
    const t = setInterval(fetchRecos, 30000);
    return () => clearInterval(t);
  }, [fetchRecos]);

  const addReco = async () => {
    if (!form.ticker || !form.source) return alert('Ticker and Source required');
    try {
      const payload = {
        ...form,
        ticker: form.ticker.toUpperCase(),
        reco_price: form.reco_price ? parseFloat(form.reco_price) : null,
        target_1: form.target_1 ? parseFloat(form.target_1) : null,
        target_2: form.target_2 ? parseFloat(form.target_2) : null,
        sl_price: form.sl_price ? parseFloat(form.sl_price) : null,
      };
      await axios.post(`${API}/recos/add`, payload);
      setForm({
        ticker: '', source: '', reason: '',
        applies_from_date: todayISO(), applies_to_date: plusDaysISO(7),
        target_strategy: 'sectortrade', notes: '',
        reco_price: '', target_1: '', target_2: '', sl_price: '',
      });
      setShowForm(false);
      fetchRecos();
    } catch (e) {
      alert('Add failed: ' + (e.response?.data?.detail || e.message));
    }
  };

  const removeReco = async (id) => {
    if (!window.confirm('Remove this reco?')) return;
    try {
      await axios.post(`${API}/recos/${id}/deactivate`);
      fetchRecos();
    } catch (e) { console.error(e); }
  };

  return (
    <div style={{
      background: 'var(--bg1)', border: `1px solid ${C.bpurple}`,
      borderRadius: 10, padding: 14, marginBottom: 12,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: C.purple }}>
          📌 My Recos ({recos.length} active)
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            fontSize: 10, padding: '4px 10px', border: 'none',
            background: C.purple, color: '#fff', borderRadius: 4,
            cursor: 'pointer', fontWeight: 600,
          }}
        >
          {showForm ? '✕ Cancel' : '+ Add Reco'}
        </button>
      </div>

      {showForm && (
        <div style={{
          background: C.lpurple, padding: 10, borderRadius: 6, marginBottom: 10,
          border: `1px solid ${C.bpurple}`,
        }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, marginBottom: 6 }}>
            <input
              type="text" placeholder="Ticker (e.g. HFCL)"
              value={form.ticker}
              onChange={e => setForm({...form, ticker: e.target.value})}
              style={{ fontSize: 10, padding: 4, borderRadius: 3, border: `1px solid ${C.bgray}` }}
            />
            <input
              type="text" placeholder="Source (e.g. CNBC, Newspaper, Anand Rathi)"
              value={form.source}
              onChange={e => setForm({...form, source: e.target.value})}
              style={{ fontSize: 10, padding: 4, borderRadius: 3, border: `1px solid ${C.bgray}` }}
            />
          </div>
          <input
            type="text" placeholder="Reason (why is it a buy?)"
            value={form.reason}
            onChange={e => setForm({...form, reason: e.target.value})}
            style={{ fontSize: 10, padding: 4, width: '100%', borderRadius: 3, border: `1px solid ${C.bgray}`, marginBottom: 6 }}
          />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 6, marginBottom: 6 }}>
            <input
              type="number" step="0.01" placeholder="Reco Price"
              value={form.reco_price}
              onChange={e => setForm({...form, reco_price: e.target.value})}
              style={{ fontSize: 10, padding: 4, borderRadius: 3, border: `1px solid ${C.bgray}` }}
            />
            <input
              type="number" step="0.01" placeholder="Target 1"
              value={form.target_1}
              onChange={e => setForm({...form, target_1: e.target.value})}
              style={{ fontSize: 10, padding: 4, borderRadius: 3, border: `1px solid ${C.bgray}` }}
            />
            <input
              type="number" step="0.01" placeholder="Target 2"
              value={form.target_2}
              onChange={e => setForm({...form, target_2: e.target.value})}
              style={{ fontSize: 10, padding: 4, borderRadius: 3, border: `1px solid ${C.bgray}` }}
            />
            <input
              type="number" step="0.01" placeholder="SL"
              value={form.sl_price}
              onChange={e => setForm({...form, sl_price: e.target.value})}
              style={{ fontSize: 10, padding: 4, borderRadius: 3, border: `1px solid ${C.bgray}` }}
            />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6 }}>
            <input
              type="date" value={form.applies_from_date}
              onChange={e => setForm({...form, applies_from_date: e.target.value})}
              style={{ fontSize: 10, padding: 4, borderRadius: 3, border: `1px solid ${C.bgray}` }}
            />
            <input
              type="date" value={form.applies_to_date}
              onChange={e => setForm({...form, applies_to_date: e.target.value})}
              style={{ fontSize: 10, padding: 4, borderRadius: 3, border: `1px solid ${C.bgray}` }}
            />
            <select
              value={form.target_strategy}
              onChange={e => setForm({...form, target_strategy: e.target.value})}
              style={{ fontSize: 10, padding: 4, borderRadius: 3, border: `1px solid ${C.bgray}` }}
            >
              <option value="sectortrade">SectorTrade</option>
              <option value="trailb">TrailB</option>
              <option value="both">Both</option>
            </select>
          </div>
          <button
            onClick={addReco}
            style={{
              fontSize: 10, padding: '5px 12px', border: 'none',
              background: C.green, color: '#fff', borderRadius: 3,
              cursor: 'pointer', fontWeight: 600, marginTop: 8,
            }}
          >
            ✓ Add Reco
          </button>
        </div>
      )}

      {recos.length === 0 ? (
        <div style={{ fontSize: 10, color: 'var(--t3)', padding: 6 }}>
          No active recos. Click "+ Add Reco" to add stock names from newspaper/TV/subscription.
        </div>
      ) : (
        <div style={{ overflow: 'auto' }}>
          <table style={{ fontSize: 10, width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: `1px solid ${C.bgray}` }}>
                <th style={{ textAlign: 'left', padding: 4 }}>Ticker</th>
                <th style={{ textAlign: 'left', padding: 4 }}>Source</th>
                <th style={{ textAlign: 'left', padding: 4 }}>Reason</th>
                <th style={{ textAlign: 'right', padding: 4 }}>Reco Rs</th>
                <th style={{ textAlign: 'right', padding: 4 }}>T1</th>
                <th style={{ textAlign: 'right', padding: 4 }}>T2</th>
                <th style={{ textAlign: 'right', padding: 4 }}>SL</th>
                <th style={{ textAlign: 'left', padding: 4 }}>Valid</th>
                <th style={{ textAlign: 'center', padding: 4 }}>Strategy</th>
                <th style={{ padding: 4 }}></th>
              </tr>
            </thead>
            <tbody>
              {recos.map(r => (
                <tr key={r.id} style={{ borderBottom: `0.5px solid ${C.lgray}` }}>
                  <td style={{ padding: 4, fontWeight: 700, color: C.purple }}>{r.ticker}</td>
                  <td style={{ padding: 4, fontSize: 9 }}>{r.source}</td>
                  <td style={{ padding: 4, fontSize: 9, color: 'var(--t3)' }}>{r.reason || '—'}</td>
                  <td style={{ padding: 4, textAlign: 'right', fontSize: 10, color: C.blue }}>
                    {r.reco_price ? Number(r.reco_price).toFixed(2) : '—'}
                  </td>
                  <td style={{ padding: 4, textAlign: 'right', fontSize: 10, color: C.green }}>
                    {r.target_1 ? Number(r.target_1).toFixed(2) : '—'}
                  </td>
                  <td style={{ padding: 4, textAlign: 'right', fontSize: 10, color: C.green }}>
                    {r.target_2 ? Number(r.target_2).toFixed(2) : '—'}
                  </td>
                  <td style={{ padding: 4, textAlign: 'right', fontSize: 10, color: C.red }}>
                    {r.sl_price ? Number(r.sl_price).toFixed(2) : '—'}
                  </td>
                  <td style={{ padding: 4, fontSize: 9, color: 'var(--t3)' }}>
                    {r.applies_from_date.slice(5)} → {r.applies_to_date.slice(5)}
                  </td>
                  <td style={{ padding: 4, textAlign: 'center', fontSize: 9 }}>{r.target_strategy}</td>
                  <td style={{ padding: 4, textAlign: 'right' }}>
                    <button
                      onClick={() => removeReco(r.id)}
                      style={{
                        fontSize: 9, padding: '2px 6px', border: 'none',
                        background: 'transparent', color: C.red,
                        cursor: 'pointer',
                      }}
                    >
                      ✕ Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
